import { useState } from "react";
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/20/solid'
import Footer from "@/components/home/footer";
import CTA from "@/components/cta";
import Header from "@/components/header";
import { fetchStrapiApi } from "@/utils/fetchStrapiApi";
import Articles from "@/components/blog/articles";
import Seo from "@/components/seo";

function MailIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M2.75 7.75a3 3 0 0 1 3-3h12.5a3 3 0 0 1 3 3v8.5a3 3 0 0 1-3 3H5.75a3 3 0 0 1-3-3v-8.5Z"
        className="fill-gray-100 stroke-gray-400 dark:fill-gray-100/10 dark:stroke-gray-500"
      />
      <path
        d="m4 6 6.024 5.479a2.915 2.915 0 0 0 3.952 0L20 6"
        className="stroke-gray-400 dark:stroke-gray-500"
      />
    </svg>
  )
}

const Blog = ({ articles }) => {
  const [ email, setEmail ] = useState('')
  const [ thankYou, setThankYou] = useState(false)
  
  const sendToSlack = async (email) => {
    try {
      let res = await fetch('/api/sendToSlack', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'email': email,
        }),
        cache: 'default'
      }) 
      //console.log(res)
      return
    } catch(e) {
      console.log(e.message)
      return
    }    
  }

  return (
    <>
      <Seo
        title="Blog | Pinto Financial"
        description=" Financial Literacy. How-To's. Free Resources. E-Books. Increasing your Financial Acumen Has Never Been Easier"
      />

      <Header />
      <div className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 mt-16">
        <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-gray-700 sm:text-5xl">Learn Small Business Financial Secrets</h1>
      </div>
      <div className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 mt-16">
        <div className="mx-auto grid max-w-xl grid-cols-1 gap-y-20 lg:max-w-none lg:grid-cols-2">
          <Articles articles={articles} />
          <div className="space-y-10 lg:pl-16 xl:pl-24 lg:ml-16">
            <div className="bg-white shadow sm:rounded-lg">
              <div className="px-4 py-5 sm:p-6">
                <h3 className="flex text-lg font-medium leading-6 text-gray-900">
                  <MailIcon className="h-6 w-6 flex-none" />
                  <span className="ml-2">Join the Pinto Newsletter</span>
                </h3>
                <div className="mt-2 max-w-xl text-sm text-gray-500">
                  <p>Join and get the secrets we discover for how other small businesses run profitable operations.</p>
                </div>
                <div className="mt-5 sm:flex sm:items-center">
                  <div className="w-full sm:max-w-xs">
                    <label htmlFor="email" className="sr-only">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={email}
                      autoComplete="email" 
                      onChange={(e) => setEmail(e.target.value)} 
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-pinto focus:ring-pinto sm:text-sm"
                      placeholder="you@example.com"
                    />
                  </div>
                  <button
                    onClick={() => { sendToSlack({type:'newsletter', email: email}); setEmail(''); setThankYou(true)}} 
                    className="mt-3 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-pinto px-4 py-2 font-medium text-white shadow-sm hover:bg-pinto-dark focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Join
                  </button>
                </div>
              </div>
            </div>

            {thankYou && <div className="rounded-md bg-green-50 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-green-800">Thanks for signing up. Secrets coming to your inbox soon!</p>
                </div>
              </div>
            </div>}

          </div>
        </div>
      </div>
      <CTA /> 
      <Footer />
    </>
  );
};

export default Blog;

export async function getStaticProps() {
  // Run API calls in parallel
  const articlesRes = await fetchStrapiApi("/articles", { populate: "*", sort: ['publishedAt:desc'] });

  //console.log(articlesRes.data);

  return {
    props: {
      articles: articlesRes.data,
    },
    revalidate: 1,
  };
}
